<template lang="pug">
  v-simple-table(v-bind="$attrs" v-on="$listeners" :style="simpleTableStyle" dense)
    template(v-for="(slot, name) in $scopedSlots" :slot="name" slot-scope="scope")
      slot(:name="name" v-bind="scope")
</template>

<script>
export default {
  name: "YzSimpleTable",
  props: {
    radius: {
      type: [String, Number],
      default: '10px'
    },
    borderColor: {
      type: String,
      default: 'yz-neutral-300'
    }
  },
  computed: {
    simpleTableStyle() {
      const style = {}
      
      style.borderRadius = typeof this.radius === 'number' ? `${this.radius}px` : this.radius
      
      if (this.borderColor) {
        style['--yz-simple-table-border-color'] = this.getFormattedColor(this.borderColor)
      }
      
      style['--yz-simple-table-radius'] = typeof this.radius === 'number' ? `${this.radius}px` : this.radius
      
      // Add border styling like YzDataTable
      style.border = `thin solid ${this.getFormattedColor(this.borderColor)}`
      style.overflow = 'hidden'
      
      return style
    }
  },
  methods: {
    getFormattedColor(color) {
      if (!color) return null
      if (color.startsWith('#')) return color
      if (color.startsWith('var(')) return color
      if (color.startsWith('yz-')) return `var(--${color})`
      return `var(--yz-${color})`
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .text-table-header, .v-data-table__wrapper > table > thead > tr > th {
    background-color: var(--yz-neutral-200);

    &:first-child {
      border-top-left-radius: var(--yz-simple-table-radius, 10px);
    }

    &:last-child {
      border-top-right-radius: var(--yz-simple-table-radius, 10px);
    }
  }
  
  .v-data-table__wrapper > table > tbody > tr > td {
    background-color: white;
  }

  .v-data-table__wrapper > table > tbody > tr:last-child > td {
    &:first-child {
      border-bottom-left-radius: var(--yz-simple-table-radius, 10px);
    }

    &:last-child {
      border-bottom-right-radius: var(--yz-simple-table-radius, 10px);
    }
  }

  /* Row borders between table rows */
  .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td {
    border-bottom: thin solid var(--yz-simple-table-border-color, var(--yz-neutral-300));
  }

  /* Header border - with higher specificity to override Vuetify defaults */
  .v-simple-table.theme--light > .v-data-table__wrapper > table > thead > tr > th,
  .v-simple-table.theme--dark > .v-data-table__wrapper > table > thead > tr > th,
  .v-data-table__wrapper > table > thead > tr > th {
    border-bottom: thin solid var(--yz-simple-table-border-color, var(--yz-neutral-300)) !important;
  }

  /* Remove default Vuetify borders */
  .v-simple-table {
    background-color: transparent;
  }

  .v-data-table__wrapper {
    border: none !important;
    overflow: visible;
  }

  .v-data-table__wrapper > table {
    border: none !important;
    width: 100%;
  }
}
</style>